import ColorfulPicker from './colorful-picker';
export default ColorfulPicker;
